import {FC} from 'react'
import {useParams} from 'react-router-dom'
import {cdrAPI} from '../../../../services/CDRService'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

type Props = {
  data: string
}

const LrItemLine: FC<Props> = ({data}) => {
  const {appId} = useParams()
  const {data: cdrLines} = cdrAPI.useGetLinesQuery(appId!)

  const line = cdrLines?.lines.find((i) => i.number === data)

  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex justify-content-start flex-column me-3 text-gray-800'>
        <span className='small text-gray-900'>
          {line !== undefined ? (
            <>
              <OverlayTrigger
                delay={{show: 50, hide: 50}}
                overlay={
                  <Tooltip id='tooltip-title' style={{position: 'fixed'}}>
                    {data}
                  </Tooltip>
                }
              >
                <span className='text-gray-800'>
                  {line.name.length > 27 ? `${line.name.slice(0, 27)}...` : line.name}
                </span>
              </OverlayTrigger>
            </>
          ) : (
            <span className='text-gray-800'>{data}</span>
          )}
        </span>
      </div>
    </div>
  )
}

export {LrItemLine}
